import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useState } from 'react';

import { CreateEditInteractionRuleFragment } from './CreateEditInteractionRuleFragment';
import { InteractionsRulesList } from './RulesList';
import { ActionPermissions, CustomPermission } from '../../../@types';
import { Button, ButtonVariantProps } from '../../../components/atoms/Button';
import { HorizontalAlignProps, InlineGroup } from '../../../components/atoms/InlineGroup';
import { Modal } from '../../../components/atoms/Modal';
import { PageContainer } from '../../../components/atoms/PageContainer';
import { Typography, TypographyVariantProps } from '../../../components/atoms/Typography';
import { PLATFORM_NAME } from '../../../configs/common';
import { isUserHasPermission } from '../../../configs/permissions';
import { TabHandler } from '../../../handlers/TabHandler';
import { useGetUserSystemPermissions } from '../../../queries/user-query';
import { Wrapper } from '../../../styled/common.styles';

export const InteractionsRules: React.FC = () => {
  const [permissions, setPermissions] = useState<CustomPermission[]>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const getUserPermissionsQuery = useGetUserSystemPermissions();

  useEffect(() => {
    getUserPermissionsQuery.data && setPermissions(getUserPermissionsQuery.data);
  }, [getUserPermissionsQuery.data]);

  TabHandler(`Interaction Rules | ${PLATFORM_NAME}`);
  
  return(
    <PageContainer>
      <Wrapper>
        <InlineGroup horizontal={HorizontalAlignProps.Between}>
          <Typography variant={TypographyVariantProps.H5} fontWeight={600}>
            Interaction Rules
          </Typography>
          {isUserHasPermission(ActionPermissions.Configure_Interactions_Edit_Rules, permissions) &&
            <Button variant={ButtonVariantProps.Primary} startIcon={<AddIcon />} onClick={() => setIsOpen(true)}>
              Create Rule
            </Button>
          }
          <Modal
            open={isOpen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <CreateEditInteractionRuleFragment
              openModal={isOpen}
              isEdit={false}
              handleClose={() => setIsOpen(false)}
            />
          </Modal>
        </InlineGroup>
        {permissions.length && <InteractionsRulesList canEdit={isUserHasPermission(ActionPermissions.Configure_Interactions_Edit_Rules, permissions)}/>}
      </Wrapper>
    </PageContainer>
  );
};